import { ofType, Epic } from "redux-observable";
import { catchError, map, merge, mergeMap, of, takeUntil } from "rxjs";
import { selectAuthTokens } from "../../../../features/auth/selectors/auth.selector";
import { IAction } from "../../../../interface/action.interface";
import { IErrorDto } from "../../../../interface/dto/error.dto";
import { IRootState } from "../../../../redux/root.reducer";
import { updateTrackList } from "../../../../service/list-update-tracking.api";
import { getListDetails } from "../../service/list-details.api";
import {
    ListDetailsActionType,
    IListDetailsGetAction,
    listDetailsSuccessAction,
    listDetailsErrorAction,
    ITrackListAction,
    listTrackSuccessAction,
    listTrackErrorAction,
    listDetailsNotFoundAction,
} from "./list-details.actions";

export const listDetailsEpic: Epic<IAction, IAction, IRootState> = (
    action$,
    state$,
) =>
    merge(
        action$.pipe(
            ofType<
                IListDetailsGetAction,
                ListDetailsActionType.LIST_DETAILS_GET
            >(ListDetailsActionType.LIST_DETAILS_GET),
            mergeMap(({ payload }) =>
                getListDetails(payload.listId, selectAuthTokens()).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                IListDetailsGetAction,
                                ListDetailsActionType.LIST_DETAILS_GET
                            >(ListDetailsActionType.LIST_DETAILS_GET),
                        ),
                    ),
                    map((result) =>
                        result
                            ? listDetailsSuccessAction(result)
                            : listDetailsErrorAction("Error while fetching!!"),
                    ),
                    catchError((error: IErrorDto) => {
                        if (error.status === 404) {
                            return of(listDetailsNotFoundAction());
                        }
                        return of(listDetailsErrorAction(error.message));
                    }),
                ),
            ),
        ),
        action$.pipe(
            ofType<ITrackListAction, ListDetailsActionType.LIST_TRACK>(
                ListDetailsActionType.LIST_TRACK,
            ),
            mergeMap(({ payload }) =>
                updateTrackList(
                    state$.value.listPage.listDetails.details!.listId,
                    payload.track,
                    selectAuthTokens(),
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType<
                                ITrackListAction,
                                ListDetailsActionType.LIST_TRACK
                            >(ListDetailsActionType.LIST_TRACK),
                        ),
                    ),
                    map((result) =>
                        result
                            ? listTrackSuccessAction()
                            : listTrackErrorAction("Error while fetching!!"),
                    ),
                    catchError((error: IErrorDto) =>
                        of(listTrackErrorAction(error.message)),
                    ),
                ),
            ),
        ),
    );
